import { UserTypes } from 'store/auth/types'
import { KnownDowntimePeriod, SystemDownTypes } from 'types/downtime'
import { LANGUAGES } from '@boltenergy-be/shared'

/**
 * Function to create a downtime period based on a start and end date
 *
 * @param {Date} start
 * @param {Date} end
 * @param {boolean} external
 * @param {UserTypes[]} userTypes
 * @param {SystemDownTypes} downtimeType
 * @returns {KnownDowntimePeriod}
 */
export const createDowntimePeriod = (
  start: Date,
  end: Date,
  external: boolean,
  userTypes: UserTypes[],
  downtimeType: SystemDownTypes
): KnownDowntimePeriod => {
  // Check if maintenance period is multi-day
  const isMultiDay = start.toISOString().split('T')[0] !== end.toISOString().split('T')[0]

  switch (downtimeType) {
    case SystemDownTypes.MAINTENANCE:
      return {
        start,
        end,
        userTypes,
        customMessage: {
          [LANGUAGES.NL]: isMultiDay
            ? `Door onderhoud ${external ? 'bij een externe partner' : ''} is My Bolt niet beschikbaar van ${start.toLocaleDateString('nl-BE', { weekday: 'long' })} ${start.toLocaleDateString('nl-BE', { day: 'numeric', month: '2-digit' })} - ${start.toLocaleTimeString('nl-BE', { hour: '2-digit' })} u. tot ${end.toLocaleDateString('nl-BE', { weekday: 'long' })} ${end.toLocaleDateString('nl-BE', { day: 'numeric', month: '2-digit' })} - ${end.toLocaleTimeString('nl-BE', { hour: '2-digit' })} u. Onze excuses hiervoor.`
            : `Door onderhoud ${external ? 'bij een externe partner' : ''} is My Bolt niet beschikbaar op ${start.toLocaleDateString('nl-BE', { weekday: 'long' })} ${start.toLocaleDateString('nl-BE', { day: 'numeric', month: 'long' })} van ${start.toLocaleTimeString('nl-BE', { hour: '2-digit' })} tot ${end.toLocaleTimeString('nl-BE', { hour: '2-digit' })} uur. Onze excuses hiervoor.`,
          [LANGUAGES.FR]: isMultiDay
            ? `My Bolt sera temporairement indisponible du ${start.toLocaleDateString('fr-BE', { weekday: 'long' })} ${start.toLocaleDateString('fr-BE', { day: 'numeric', month: '2-digit' })} à ${start.toLocaleTimeString('fr-BE', { hour: '2-digit' })} au ${end.toLocaleDateString('fr-BE', { weekday: 'long' })} ${end.toLocaleDateString('fr-BE', { day: 'numeric', month: '2-digit' })} à ${end.toLocaleTimeString('fr-BE', { hour: '2-digit' })}, en raison d’une maintenance ${external ? 'chez un partenaire externe' : ''}. Merci pour votre compréhension.`
            : `My Bolt sera temporairement indisponible ce ${start.toLocaleDateString('fr-BE', { weekday: 'long' })} ${start.toLocaleDateString('fr-BE', { day: 'numeric', month: 'long' })}, de ${start.toLocaleTimeString('fr-BE', { hour: '2-digit' })} à ${end.toLocaleTimeString('fr-BE', { hour: '2-digit' })}, en raison d’une maintenance ${external ? 'chez un partenaire externe' : ''}. Merci pour votre compréhension.`
        }
      }
    default:
      return {
        start,
        end,
        userTypes
      }
  }
}
